export default __webpack_public_path__ + "b53584b245837b2fc794cb08d261d31c.svg";